// ID завода с бу автомобилями
export const USED_CAR_FACTORY_ID = 36;

// Порядок заводов в выпадающем списке (перечисленные идут первыми, остальные — как с бэкенда)
export const FACTORY_ORDER_PRIORITY = ['САП', 'AMQ'];

// Типы происхождения автомобилей
export const CAR_ORIGIN_TYPES = {
  NEW_KZ: 1,                    // Новое авто, произведённое в Казахстане
  NEW_IMPORT: 2,            // Новое авто, ввезённое
  PURCHASE: 3,                // Выкуп у клиента
  PLEDGED_PURCHASE: 4, // Выкуп залогового авто
  EXCHANGE: 5,                // По договору мены
  CONSIGNMENT: 6,          // По договору поручения
  CONSIGNMENT_FIRST_REG: 7, // По договору поручения, первичная регистрация
};

// Описания типов происхождения
export const CAR_ORIGIN_LABELS = {
  [CAR_ORIGIN_TYPES.NEW_KZ]: 'Новое авто, произведённое в Казахстане',
  [CAR_ORIGIN_TYPES.NEW_IMPORT]: 'Новое авто, ввезённое',
  [CAR_ORIGIN_TYPES.PURCHASE]: 'Выкуп у клиента',
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: 'Выкуп залогового авто',
  [CAR_ORIGIN_TYPES.EXCHANGE]: 'По договору мены',
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: 'По договору поручения',
  [CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG]: 'По договору поручения, первичная регистрация',
};

// У серых дилеров поручение — это просто БУ-авто, и так оно подписано в формах; значения (6 и 7) те же.
export const SHORT_FORM_ORIGIN_LABELS = {
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: 'БУ авто',
  [CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG]: 'Первичная регистрация',
};

export const originLabel = (value, short = false) =>
  (short && SHORT_FORM_ORIGIN_LABELS[value]) || CAR_ORIGIN_LABELS[value];

// Поручение: 6 — обычное, 7 — с первичной регистрацией (банкам уходит её признак)
export const CONSIGNMENT_ORIGINS = [CAR_ORIGIN_TYPES.CONSIGNMENT, CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG];
export const isConsignmentOrigin = (origin) => CONSIGNMENT_ORIGINS.includes(origin);

// Типы, требующие процесс выкупа
export const PURCHASE_PROCESS_TYPES = [
  CAR_ORIGIN_TYPES.PURCHASE,
  CAR_ORIGIN_TYPES.PLEDGED_PURCHASE,
  CAR_ORIGIN_TYPES.EXCHANGE,
  ...CONSIGNMENT_ORIGINS,
];

// Типы документов выкупа
export const PURCHASE_DOCUMENT_TYPES = {
  PURCHASE_CONTRACT: 'purchase_contract',       // Договор выкупа
  INSPECTION_ACT: 'inspection_act',            // Акт приёмки/осмотра
  CAR_PHOTOS: 'car_photos',                    // Фотографии автомобиля
  SIGNED_CONTRACT: 'signed_contract',          // Подписанный договор
};

// Типы договоров по происхождению
export const CONTRACT_TYPES_BY_ORIGIN = {
  [CAR_ORIGIN_TYPES.PURCHASE]: 'purchase',
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: 'pledged_purchase',
  [CAR_ORIGIN_TYPES.EXCHANGE]: 'exchange',
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: 'consignment',
  [CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG]: 'consignment',
};

// Статусы обработки выкупа
export const PURCHASE_STATUS = {
  PENDING: 'pending',           // В обработке
  DOCUMENTS_UPLOADED: 'docs_uploaded', // Документы загружены
  CONTRACT_GENERATED: 'contract_generated', // Договор сгенерирован
  CONTRACT_SIGNED: 'contract_signed', // Договор подписан
  COMPLETED: 'completed',       // Завершено
  CANCELLED: 'cancelled',       // Отменено
};

// Требуемые документы для каждого типа
export const REQUIRED_DOCUMENTS_BY_TYPE = {
  [CAR_ORIGIN_TYPES.PURCHASE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.PLEDGED_PURCHASE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.EXCHANGE]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.INSPECTION_ACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.CONSIGNMENT]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
  [CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG]: [
    PURCHASE_DOCUMENT_TYPES.PURCHASE_CONTRACT,
    PURCHASE_DOCUMENT_TYPES.CAR_PHOTOS,
  ],
}; 